module.exports = __webpack_public_path__ + "static/media/219-Milo-Platz_ID_1w.ff9eec35.mp3";